<aside class="sidebar-area">
    <div class="widget widget_categories  ">
        <h3 class="widget_title">Our Services</h3>
        <ul>
            <li>
                <a routerLink="/website-development">Web Developments</a>
                <span><i class="fa-regular fa-arrow-up-right"></i></span>
            </li>
            <li>
                <a routerLink="/design">UX/UI Design</a>
                <span><i class="fa-regular fa-arrow-up-right"></i></span>
            </li>
            <li>
                <a routerLink="/mobile-development">App Development</a>
                <span><i class="fa-regular fa-arrow-up-right"></i></span>
            </li>
            <li>
                <a routerLink="/ai-assisted-integrations">AI Assisted Integrations</a>
                <span><i class="fa-regular fa-arrow-up-right"></i></span>
            </li>
            <li>
                <a routerLink="/ios-development">iOS Development</a>
                <span><i class="fa-regular fa-arrow-up-right"></i></span>
            </li>
            <li>
                <a routerLink="/android-development">Android Development</a>
                <span><i class="fa-regular fa-arrow-up-right"></i></span>
            </li>
            <li>
                <a routerLink="/logo-design">Logo Design</a>
                <span><i class="fa-regular fa-arrow-up-right"></i></span>
            </li>
            <li>
                <a routerLink="/seo-services">SEO Services</a>
                <span><i class="fa-regular fa-arrow-up-right"></i></span>
            </li>
            <li>
                <a routerLink="/software-development">Software Development</a>
                <span><i class="fa-regular fa-arrow-up-right"></i></span>
            </li>
        </ul>
    </div>
    <div class="widget widget_banner  " data-bg-src="assets/img/bg/widget_banner.jpg">
        <div class="widget-banner position-relative text-center">
            <span class="icon"><i class="fa-solid fa-phone"></i></span>
            <span class="text">Need Help? Call Here</span>
            <a class="phone" href="tel:+918090920216">+91-8090-920216</a>
            <a routerLink="/contact" class="th-btn style6">Get A Quote <i class="fa-light fa-arrow-right-long"></i></a>
        </div>
    </div>
</aside>